<template>
    <div class="params-header" style="margin-top: 20px">
        <Card :no-border="false">
            <div class="condition-line" style="display: flex; border-bottom: 1px solid #f7f7f7">
                <div class="block" style="flex: 3">
                    <label><i class="el-icon-location-information"></i>:</label>
                    <el-popover v-model:visible="showPopover" ref="popover1" placement="bottom-start" width="600px" trigger="manual">
                        <template #reference>
                            <el-button @click="showPopover = !showPopover" size="small">{{ nodeName }}</el-button>
                        </template>
                        <div style="width: 600px">
                            <div style="padding: 10px">
                                <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                            </div>
                            <el-tree
                                class="my-tree"
                                ref="tree"
                                style="margin-top: 5px"
                                :data="treeData"
                                node-key="EntityID"
                                :current-node-key="params.EntityID"
                                default-expand-all
                                highlight-current
                                :expand-on-click-node="false"
                                :filter-node-method="filterNode"
                                @node-click="handleNodeClick"
                            >
                                <template #default="{ data }">
                                    <div class="custom-tree-node">
                                        <span class="menu-icon icon-org" v-if="data.EntityType == 101"></span>
                                        <span class="menu-icon icon-shop" v-if="data.EntityType == 1"></span>
                                        <span class="menu-icon icon-floor" v-if="data.EntityType == 2"></span>
                                        <span class="menu-icon icon-market" v-if="data.EntityType == 3"></span>
                                        <span>{{ data["EntityName"] }}</span>
                                    </div>
                                </template>
                            </el-tree>
                        </div>
                    </el-popover>
                </div>
                <div style="flex: 7; text-align: right">
                    <div class="block">
                        <el-date-picker size="mini" v-model="params.Date" v-bind="dataConf"></el-date-picker>
                    </div>
                    <div class="block">
                        <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
                    </div>
                </div>
            </div>
            <div class="condition-line" v-if="$slots.buttons">
                <slot name="buttons"></slot>
            </div>
        </Card>
    </div>
</template>

<script>
export default {
    name: "ParamsHeader2",
    props: {
        dateType: {
            type: String,
            default: () => "date",
        },
        dataConf: {
            type: Object,
            default: () => ({
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始日期",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD",
                "end-placeholder": "结束日期",
            }),
        },
    },
    data() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return {
            params: {
                type: "2",
                EntityID: "",
                Date: this.dateTypeAdaptor(this.dataConf.type),
            },
            shortcut: 0,
            type: "2",
            /*----- 处理树形选择 START ----- */
            treeData: [],
            nodeName: "",
            filterText: "",
            showPopover: false,
            /*----- 处理树形选择 END ----- */
        };
    },
    methods: {
        getEntitys() {
            this.$ajax
                .post("/Entity/GetEntityTree")
                .then((result) => {
                    this.treeData = result.Data;
                    if (result.Data.length > 0) {
                        this.params.EntityID = result.Data[0].EntityID;
                        this.nodeName = result.Data[0].EntityName;
                        this.$emit("searchParams", this.params);
                    }
                })
                .catch((err) => {});
        },
        dateTypeAdaptor(type) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            switch (type) {
                case "date":
                    return start.format("yyyy-MM-dd");
                case "daterange":
                    return [start.format("yyyy-MM-dd"), end.format("yyyy-MM-dd")];
                case "month":
                    return start.format("yyyy-MM");
                case "year":
                    return start.format("yyyy");
            }
        },
        handleSearch() {
            this.$emit("searchParams", this.params);
            this.$forceUpdate();
        },
        getInitParams() {
            return this.params;
        },
        /*------ 处理树形选择 START ------  */
        filterNode(value, data) {
            if (!value) return true;
            console.log(data);
            return data["EntityName"].includes(value);
        },
        handleNodeClick(data) {
            this.nodeName = data["EntityName"];
            this.params.EntityID = data["EntityID"];
            this.showPopover = false;
        },
        /*------ 处理树形选择 END ------  */
    },
    created() {
        this.getEntitys();
    },
    watch: {
        shortcut(val) {
            this.changeShortcut(val);
            this.$emit("searchParams", this.params);
        },
        filterText(val) {
            this.$refs.tree.filter(val);
        },
    },
};
</script>

<style scoped>
.linkText {
    color: #333333;
    margin-right: 10px;
}
.active {
    color: #52c0ec;
}

.custom-tree-node .menu-icon {
    width: 20px;
    font-size: 18px;
    position: relative;
}
</style>
